import { CustomerHistoryMediaType } from "@/common/types";

export interface ContactBase {
	id: string;
	name: string;
	givenName: string;
	surname: string;
	email: string;
	userPrincipalName: string;
	mobilePhone: string;
	businessPhone: string;
	jobTitle: string;
	department: string;
	companyName: string;
	office: string;
	city: string;
	country: string;
	creatorId: string;
}

export interface ContactListItem extends ContactBase {
	queueIds: string[];
	contactType: ContactType;
	isImported: boolean;
	hasCC4TeamsClient: boolean;
	hasContactNotes: boolean;
}

export enum ContactFilterField {
	JobTitle = 0,
	Department = 1,
	City = 2,
	Office = 3,
	Country = 4,
	CompanyName = 5,
}

/**
 * One advanced-filter value. `value` is the term the search index holds and the filter matches on;
 * `label` is the same value in the casing the directory uses, for display only.
 */
export interface ContactFilterValue {
	value: string;
	label: string;
}

export interface ContactsAdvancedFilter {
	jobTitles: ContactFilterValue[];
	departments: ContactFilterValue[];
	cities: ContactFilterValue[];
	companyNames: ContactFilterValue[];
	offices: ContactFilterValue[];
	countries: ContactFilterValue[];
}

export interface ContactDto extends ContactBase {
	queueIds: string[];
	mobilePhoneNumber: string;
	businessPhoneNumber: string;
}

export interface AddOrUpdateContact {
	contact: ContactDto;

	interactionId: string;

	interactionType: CustomerHistoryMediaType;
}

export enum ContactType {
	Database = 0,
	AzureActiveDirectory = 1,
	Office365 = 2,
}

export interface ShortContactInfo {
	id: string;
	name: string;
	email: string;
	userPrincipalName: string;
	mobilePhone: string;
	businessPhone: string;
	jobTitle: string;
	department: string;
}
